import { handleExecFail } from '../../business/activity/handle-exec-fail';
import { GetCouponType, handleGetCoupon, handleQryCoupon, QryCouponType, transformCoupons } from '../../business';
import { ActivityCouponState, ActType } from '../../types';
import { CouponActivity } from './coupon-activity';
import { ExecActState, GoodsType, promShowGoodsInfo } from '@tencent/wphk-act-base-cgi';
import { leftJoin } from '../../utils';
/** 每张券的状态权重 默认配置 */
const DEFAULT_COUPON_SORT_STATE = [
    ActivityCouponState.expired,
    ActivityCouponState.received,
    ActivityCouponState.totalLimit,
    ActivityCouponState.dayLimit,
    ActivityCouponState.notReceived,
];
/**
 * 派发活动
 */
export class DistributionActivity extends CouponActivity {
    constructor(distributionActivityOpts) {
        var _a, _b;
        super(distributionActivityOpts.couponActRelation);
        /** 活动类型 */
        this.type = ActType.distribution;
        /** 券静态信息 */
        this.couponGoodsInfo = [];
        this.distributeActidList = distributionActivityOpts.distributeActidList;
        this.isNeedUserCouponid = (_a = distributionActivityOpts.isNeedUserCouponid) !== null && _a !== void 0 ? _a : true;
        this.isNeedCouponGoodsInfo = distributionActivityOpts.isNeedCouponGoodsInfo;
        this.couponStateSort = (_b = distributionActivityOpts.couponStateSort) !== null && _b !== void 0 ? _b : DEFAULT_COUPON_SORT_STATE;
    }
    /** 初始化活动信息 */
    async initAct() {
        /** 拉取券列表 */
        await this.qryCoupon();
    }
    /** 参与活动 */
    async execAct() {
        if (super.beforeExecAct()) {
            // getCoupon
        }
    }
    /** 查询并设置活动状态 */
    async setActState() { }
    /** 查询并设置用户参与活动状态 */
    async setUserActState() { }
    /** 查券 */
    async qryCoupon() {
        const list = await handleQryCoupon[QryCouponType.ExchActPrizeInfoByActId](this.type, this.couponActRelation, this.distributeActidList);
        // 券加密串id数组
        const couponPrizeIdList = list.map(coupon => coupon.prizeId);
        const qryPromiseList = [];
        if (this.isNeedUserCouponid) {
            // 查用户券信息：为了拿到userCouponId
            qryPromiseList.push(this.getUserCouponList(couponPrizeIdList));
        }
        if (this.isNeedCouponGoodsInfo && this.couponGoodsInfo.length === 0) {
            // 查goodsInfo信息：(优化)如果couponGoodsInfo不为空，则不查goodItem，即第二次以后不查，适用于更新券列表场景
            qryPromiseList.push(this.qryGoodsInfo(couponPrizeIdList));
        }
        if (qryPromiseList.length !== 0) {
            await Promise.all(qryPromiseList);
        }
        this.couponList = this.mergeAndFormatAllCouponInfo(list) || [];
    }
    /**
     * 领券
     * 领成功 或 cgi返回了不在预期内的execState => 保持原来格式返回
     * 领失败 => throw error
     */
    async getCoupon(params) {
        if (!params || !params.actListid || !params.prizeId) {
            throw new Error('参数错误');
        }
        const { actListid, prizeId, spId } = params;
        const { execState } = await handleGetCoupon[GetCouponType.ExecAct](actListid, prizeId, spId);
        if (ExecActState.success !== execState) {
            handleExecFail(execState);
        }
        return {
            isSuccess: true,
        };
    }
    /** 获取用户领到的券 */
    async getUserCouponList(couponIdList) {
        const list = await handleQryCoupon[QryCouponType.QryUserCouponList](couponIdList);
        this.userCouponList = list;
    }
    async qryGoodsInfo(couponPrizeIdList) {
        const res = await promShowGoodsInfo({ goodsType: GoodsType.coupon, goodsIdList: couponPrizeIdList });
        this.couponGoodsInfo = res === null || res === void 0 ? void 0 : res.goodsArr;
    }
    /** 合并券：couponList(券兑换活动信息)+兑换活动状态信息，userCouponList(用户券信息)，goodsInfo(券静态信息) */
    mergeAndFormatAllCouponInfo(couponList) {
        if (!couponList) {
            return couponList;
        }
        const transformedList = transformCoupons({
            couponList,
            userCouponList: this.userCouponList,
            couponStateSort: this.couponStateSort,
        });
        const transformedListWithGoodsInfo = leftJoin(leftJoin(couponList, transformedList, 'couponId', 'couponId'), this.couponGoodsInfo, 'couponId', 'goodsId');
        return transformedListWithGoodsInfo;
    }
}
